// Who can use which part of the app — ONE table of capabilities over the user's
// Navision Resource flags (from /auth/me: navisionWebAccess, accountingAccess,
// executiveAccess, budgetAccess, budgetAdmin, isAdmin). Mirrors
// server/services/access.js with the same capability names, so the screens and
// the API agree. When permissions move to a permission table (or a direct pull of
// Navision permissions), only these rules change.

const has = (u, flag) => !!(u && u[flag]);
const any = (...flags) => (u) => flags.some((f) => has(u, f));

export const CAPABILITIES = {
  // Jobs section
  createInvoices: any('navisionWebAccess', 'accountingAccess', 'executiveAccess'),
  createInvoicesAllJobs: any('accountingAccess'),
  invoiceApproval: any('executiveAccess', 'accountingAccess'),
  budget: any('navisionWebAccess', 'accountingAccess', 'executiveAccess'),
  budgetAllJobs: any('accountingAccess', 'executiveAccess'),
  entries: any('navisionWebAccess', 'accountingAccess', 'executiveAccess'),
  // Receivables
  receivables: any('navisionWebAccess', 'accountingAccess', 'executiveAccess'),
  receivablesAllJobs: any('accountingAccess', 'executiveAccess'),
  receivablesEdit: any('accountingAccess'),
  outlookInvoicePosting: any('accountingAccess'),
  // Projections (the forecast of future amounts)
  projections: any('budgetAccess'),
  projectionsAdmin: any('budgetAdmin'),
  // Analytics > Reports: the user's PM / Director jobs; all jobs for Executive
  reports: any('navisionWebAccess', 'accountingAccess', 'executiveAccess'),
  reportsAllJobs: any('executiveAccess'),
  // Administration
  admin: any('isAdmin'),
};

export function can(user, capability) {
  const rule = CAPABILITIES[capability];
  if (!rule) throw new Error(`Unknown capability "${capability}"`);
  return rule(user);
}

// Named helpers kept for existing callers (each is one capability).
export const canSeeBudget = (user) => can(user, 'projections');
export const canSeeBudgetAdmin = (user) => can(user, 'projectionsAdmin');
export const isAccountingUser = (user) => can(user, 'createInvoicesAllJobs');
export const isExecutiveUser = (user) => has(user, 'executiveAccess');
export const canSeeInvoices = (user) => can(user, 'receivables');
export const canSeeCreateInvoices = (user) => can(user, 'createInvoices');
export const canSeeJobBudget = (user) => can(user, 'budget');
export const canSeeInvoiceApproval = (user) => can(user, 'invoiceApproval');
